import { ACTIVE_MERCHANT } from "../../utils/constants";
import {
  CHECK_KYC_SEEN,
  SET_BLOCKED,
  SET_USER,
  SET_USER_DATA,
  SIGN_OUT,
  SET_MFA,
  SET_FEEDBACK_SURVEY_STATE,
  SET_MERCHANT,
  SET_MERCHANTS,
  SET_CONFIGURATIONS,
  SET_NOTIFICATION
} from "../actions/actionTypes";

const initialState = {
  user: null,
  tokens: null,
  isAuthenticated: false,
  role: "guest",
  blocked: false,
  kycSeen: false,
  fcmToken: null,
  mfaEnabled: false,
  account: null,
  accounts: null,
  configuration: null,
  notification: null
};
function AuthReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        isAuthenticated: true,
        tokens: action.payload,
        role: "user",
      };
    case SIGN_OUT:
      return {
        ...initialState,
      };
    case SET_USER_DATA:
      return {
        ...state,
        user: action.payload,
      };
    case SET_BLOCKED:
      return {
        ...state,
        blocked: action.payload,
      };
    case CHECK_KYC_SEEN:
      return {
        ...state,
        kycSeen: action.payload,
      };
    case SET_MFA:
      return {
        ...state,
        mfaEnabled: action.payload
      };
    case SET_FEEDBACK_SURVEY_STATE:
      return {
        ...state,
        feedbackSurveyState: action.payload
      };
    case SET_MERCHANT:
      localStorage.setItem(ACTIVE_MERCHANT, action?.payload?.payoutAccount?.id);
      return {
        ...state,
        account: action.payload
      }
      case SET_MERCHANTS:
        return {
          ...state,
          accounts: action.payload
        }
      case SET_CONFIGURATIONS:
        return {
         ...state,
          configuration: action.payload
        }
      case SET_NOTIFICATION:
        return {
          ...state,
          notification: action.payload
        }
    default:
      return state;
  }
}
export default AuthReducer;
